import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { saveToLocalStorage } from '../../configureStore';

// on location.pathname change updating local storage
const PersistStore = () => {
  const reduxState = useSelector((state) => state);
  const location = useLocation();
  useEffect(() => {
    saveToLocalStorage(reduxState);
  }, [location.pathname]);

  return null;
};

export default PersistStore;
